<template>
  <v-app>

    <core-background/>

    <core-drawer v-if="auth.authenticated"/>

    <core-view/>

    <core-messages/>

  </v-app>
</template>

<script>
import { mapState } from "vuex";

export default {
  metaInfo() {
    return {
      title: process.env.VUE_APP_TITLE
    };
  },
  computed: {
    ...mapState(["auth"])
  },
  methods: {
    changeFavicon(src) {
      var link = document.createElement("link"),
        oldLink = document.getElementById("dynamic-favicon");
      link.id = "dynamic-favicon";
      link.rel = "shortcut icon";
      link.href = src;
      if (oldLink) {
        document.head.removeChild(oldLink);
      }
      document.head.appendChild(link);
    }
  },
  mounted() {
    this.changeFavicon(
      require("../public/img/favicon/" + process.env.VUE_APP_FAVICON)
    );
  }
};
</script>


<style lang="scss">
@import "@/styles/index.scss";

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}

#app {
  font-family: "Work Sans", sans-serif;
  background-color: transparent !important;
}
</style>
